import { useEffect, useState } from 'react'

const IDLE_MS = 3_000

export function useAdminScreenWakeLock(active: boolean) {
  useEffect(() => {
    if (!active || !('wakeLock' in navigator)) return
    let sentinel: WakeLockSentinel | null = null
    let disposed = false
    const acquire = async () => {
      if (document.visibilityState !== 'visible' || sentinel?.released === false) return
      try {
        const next = await navigator.wakeLock.request('screen')
        if (disposed) {
          void next.release()
          return
        }
        sentinel = next
      } catch {
        sentinel = null
      }
    }
    const onVisibilityChange = () => {
      void acquire()
    }
    void acquire()
    document.addEventListener('visibilitychange', onVisibilityChange)
    return () => {
      disposed = true
      document.removeEventListener('visibilitychange', onVisibilityChange)
      void sentinel?.release().catch(() => undefined)
    }
  }, [active])
}

export function useAdminLiveStageIdle(active: boolean) {
  const [idle, setIdle] = useState(false)
  useEffect(() => {
    if (!active) return
    const reset = window.setTimeout(() => setIdle(false), 0)
    let timer = window.setTimeout(() => {
      setIdle(true)
    }, IDLE_MS)
    const wake = () => {
      setIdle(false)
      window.clearTimeout(timer)
      timer = window.setTimeout(() => {
        setIdle(true)
      }, IDLE_MS)
    }
    const events = ['pointermove', 'pointerdown', 'keydown', 'touchstart'] as const
    for (const event of events) window.addEventListener(event, wake)
    return () => {
      window.clearTimeout(reset)
      window.clearTimeout(timer)
      for (const event of events) window.removeEventListener(event, wake)
    }
  }, [active])
  return active && idle
}
